import { render } from "./TelehealthServicesPage.vue?vue&type=template&id=600c3485&scoped=true"
import script from "./TelehealthServicesPage.vue?vue&type=script&lang=js"
export * from "./TelehealthServicesPage.vue?vue&type=script&lang=js"

import "./TelehealthServicesPage.vue?vue&type=style&index=0&id=600c3485&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600c3485"]])

export default __exports__